module.exports = __webpack_public_path__ + "static/8-4a3f7449073867d60c4822e2d6600ca7.jpeg";